import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnavailableLunComponent } from './unavailable-lun.component';
import { CoreModule } from '@dm/core';

@NgModule({
    declarations: [UnavailableLunComponent],
    exports: [UnavailableLunComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
})
export class UnavailableLunModule { }
